import {
  purchaseTableItemHeaders,
  listingTableItemHeaders,
  listingTableItemHeadersSold,
} from "@/config/tableData";
import SubCells from "./SubCells";
import { ListingWithItems, PurchaseWithItems } from "@/types";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import MobilePurchaseSubHeaders from "./SubHeader/Mobile/MobilePurchaseSubHeaders";
import MobileListingSubHeaders from "./SubHeader/Mobile/MobileListingSubHeaders";
import { cn } from "@/lib/utils";

interface TableData<T> {
  data: T;
  table: string;
}

type SubTableProps = TableData<ListingWithItems | PurchaseWithItems>;

export default function SubTable({ data, table }: SubTableProps) {
  const isMobile = useMediaQuery("mobile");
  const subTableHeaders =
    table === "purchases"
      ? purchaseTableItemHeaders
      : (data as ListingWithItems).listingSold
        ? listingTableItemHeadersSold
        : listingTableItemHeaders;

  const rightHeaders = ["actions"];
  const cellSizes = subTableHeaders
    .map((header) => header.size)
    .join(" ")
    .toString();

  const getSubHeaders = () => {
    if (table === "purchases") {
      return <MobilePurchaseSubHeaders data={data as PurchaseWithItems} />;
    } else {
      return <MobileListingSubHeaders data={data as ListingWithItems} />;
    }
  };

  return (
    <div className="relative w-full pl-2 pt-2 text-left text-xs">
      <div className="mr-3 rounded-sm border-t border-l border-r">
        {/* Headers */}
        <div
          className={cn("grid bg-table-header", isMobile ? "p-0" : "p-2")}
          style={{
            gridTemplateColumns: cellSizes,
          }}
        >
          {subTableHeaders.map((header: { slug: string; label: string }) => (
            <div
              key={header.slug}
              className="text-xs"
              style={{
                textAlign: rightHeaders.includes(header.slug)
                  ? "right"
                  : "left",
              }}
            >
              {/* No headers on mobile sub-tables */}
              {isMobile ? <></> : <span>{header.label}</span>}
            </div>
          ))}
        </div>

        {/* Body */}
        <div>
          {/* Sub-table header */}
          {isMobile && getSubHeaders()}

          {/* Sub-table body */}
          {data.items.map((item) => (
            <div
              key={item.itemName}
              className="grid px-2 py-1 bg-muted/60 last:rounded-b-sm last:border-b"
              style={{
                gridTemplateColumns: cellSizes,
              }}
            >
              <SubCells
                item={item}
                listingData={data as ListingWithItems}
                table={table as "listings"}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
